import Vue from "vue";

export default {
  // Get a job application by ID
  getJobApplicationById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/recruitment/job-application/${id}`)
        .then(response => {
          commit("setSelectedRow", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Create a new job application
  createJobApplication({ commit }, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/recruitment/job-application`, params)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
          commit("tableLoading", false);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
          commit("tableLoading", false);
        });
    });
  },

  handleSizeChangeJobApplication({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    dispatch("getAllJobApplications");
  },
  handleCurrentChangeJobApplication({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getAllJobApplications");
  },

  // Get all job applications
  getAllJobApplications({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);
      const params = {
        page: state.currentPage,
        per_page: state.perPage,
        status: state.status,
        ...(payload && payload),
      };
      Vue.$http
        .get("/hrm/recruitment/job-application", { params })
        .then(response => {
          commit("jobApplications", response.data.results);
          commit("paginationTotal", response.data.total);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  // Delete a job application by ID
  deleteJobApplication(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/hrm/recruitment/job-application/${id}`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Update job application status by ID
  updateJobApplicationStatus(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/recruitment/job-application/update-status`, payload)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
